import moment from "moment";
import * as actionTypes from "./actionTypes";
import {ModificheService} from "../../../api/modificheService";
import {store} from "../../store";
import {toastError} from "../../../shared/components/toast/Toast";
import fileSaver from "file-saver/dist/FileSaver";

export const getModificheData = (integrationId, page, rowsPerPage, sorting, filter) => {
    const sortParts = sorting.split(",")
    const ruleName = filter.nomeRegola.value
    const msisdn = filter.numeroDiTelefono.value
    const startDate = filter.dateModified.from ? moment(filter.dateModified.from).format("YYYYMMDD") : undefined
    const endDate = filter.dateModified.to ? moment(filter.dateModified.to).format("YYYYMMDD") : undefined
    const username = filter.username.value

    return (dispatch) => {
        dispatch({type: actionTypes.GET_MODIFICHE_DATA_LOADING, value: true})
        ModificheService.fetchModificheData(integrationId, page, rowsPerPage, sortParts[0], sortParts[1].toUpperCase(),
            null, msisdn, ruleName, null, username, null, startDate, endDate)
            .then((res) => {
                dispatch({
                    type: actionTypes.GET_MODIFICHE_DATA,
                    payload: res.data.eventLogs ?? [],
                    count: res.data.totalElements ?? 0
                })
            })
            .catch((e) => {
                console.log(e);
            })
            .finally(() => {
                dispatch({type: actionTypes.GET_MODIFICHE_DATA_LOADING, value: false});
            })
    }
}

export const getModificheDetails = (modificheId) => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId;
    return (dispatch) => {
        dispatch({type: actionTypes.GET_MODIFICHE_DETAILS_LOADING, value: true})

        ModificheService.fetchModificheDetails(integrationId, modificheId)
            .then((res) => {
                dispatch({
                    type: actionTypes.GET_MODIFICHE_DETAILS_DATA,
                    payload: res.data
                })
            })
            .catch((e) => {
                console.log(e);
            })
            .finally(() => {
                dispatch({type: actionTypes.GET_MODIFICHE_DETAILS_LOADING, value: false})
            })
    }
}

export const downloadCsv = (selectedRowIds, page, rowsPerPage, filter, sort, areAllSelected) => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId
    const sortParts = sort.split(",")
    const ruleName = filter.nomeRegola.value
    const msisdn = filter.numeroDiTelefono.value
    const startDate = filter.dateModified.from ? moment(filter.dateModified.from).format("YYYYMMDD") : undefined
    const endDate = filter.dateModified.to ? moment(filter.dateModified.to).format("YYYYMMDD") : undefined
    const username = filter.username.value

    return (dispatch) => {
        dispatch({type: actionTypes.SET_DOWNLOAD_CSV, value: true})
        ModificheService.downloadCsv(selectedRowIds, integrationId, page, rowsPerPage, sortParts[0], sortParts[1].toUpperCase(),
            null, msisdn, ruleName, null, username, null, startDate, endDate, areAllSelected)
            .then(res => {
                fileSaver.saveAs(res.data, `modifiche_effetuate_${new Date().toISOString()}.csv`)
            })
            .catch(e => {
                toastError('Errore durante il download del file CSV')
                console.error(e)
            })
            .finally(() => {
                dispatch({type: actionTypes.SET_DOWNLOAD_CSV, value: false})
            })
    }
}

export const downloadCsvForAuditLogId = (auditLogId) => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId

    return (dispatch) => {
        dispatch({type: actionTypes.SET_DOWNLOAD_CSV_FOR_AUDIT_LOG_DETAILS, value: true})
        ModificheService.downloadCsvForAuditLogId(auditLogId, integrationId)
            .then(res => {
                fileSaver.saveAs(res.data, `modifiche_effetuate_${auditLogId}_${new Date().toISOString()}.csv`)
            })
            .catch(e => {
                toastError('Errore durante il download del file CSV')
                console.error(e)
            })
            .finally(() => {
                dispatch({type: actionTypes.SET_DOWNLOAD_CSV_FOR_AUDIT_LOG_DETAILS, value: false})
            })
    }
}